import React from 'react';
import ZFlixSplashLogo from './ZFlixSplashLogo';

export default function SplashRetroScan({ reducedMotion = false }) {
  return (
    <div className={`zflix-splash-stage zflix-splash-retro${reducedMotion ? ' zflix-splash-stage--static' : ''}`}>
      <div className="zflix-splash-retro-grid" aria-hidden />
      {!reducedMotion && <div className="zflix-splash-retro-scan" aria-hidden />}
      <ZFlixSplashLogo size="large" />
      <p className="zflix-splash-retro-tag">PRESS START — YOUR LIBRARY AWAITS</p>
    </div>
  );
}
